export default __webpack_public_path__ + "static/media/blank.8f48664c.jpg";